import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { Link as StyledLink } from '../../Link/index.js';

const LogoLink = styled(StyledLink)`
  flex: 0 0 auto;
  color: ${ndsTokens.colors.palette.white};
  height: 85%; /* Magic number to fill up the header, but still make the focus outline visible */
  margin: 0 ${ndsTokens.space.generic.x4} 0 ${ndsTokens.space.generic.x1};
  display: inline-flex;
  align-items: center;

  &:focus,
  &:active {
    color: ${ndsTokens.colors.palette.white};
    outline: 1px dashed ${ndsTokens.colors.palette.white};
  }
`;

export { LogoLink };
